import { Component, OnInit, ViewChild } from '@angular/core';
import { centro_costo } from '../../shared/object/centro_costo.model';
import { SecurityService } from '../../shared/services/security.service';
import { ValidadoresService } from '../../shared/validadores/validadores';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS } from 'constants';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: 'app-centro-costo',
  templateUrl: './centro-costo.component.html',
  styleUrls: ['./centro-costo.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class CentroCostoComponent implements OnInit {
  private client: GraphQLClient = null;
  public formAgregarCentroCosto: FormGroup;
  public formEditarCentroCosto: FormGroup;
  public rutEmpresa;
  public sucursalCodigo;
  public listaCentroCosto: centro_costo[];
  public centroCostoSel: centro_costo;
  public busquedaEstado;
  public nombreBusquedaCC: string;
  @ViewChild('agregarCentroCosto', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarCentroCosto', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 17;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());


  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService
  ) {
    this.client = client;
    this.formAgregarCentroCosto = this.construyeFormAgrega();
    this.formEditarCentroCosto = this.construyeFormEdita();
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();
    this.busquedaEstado = 1;
    this.nombreBusquedaCC = '';
    this.obtenerDatosCentroCosto(
      Number(this.rutEmpresa),
      Number(this.sucursalCodigo)
    );
  }

  /***************Construccion de formularios reactivos****************/
  construyeFormAgrega() {
    return new FormGroup({
      codigo: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(10),
      ]),
      nombre: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50),
      ]),
      descripcion: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100),
      ]),
      activado: new FormControl(true),
      rut_empresa: new FormControl(''),
    });
  }

  construyeFormEdita() {
    return new FormGroup({
      codigo: new FormControl({ value: '', disabled: true }, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(10),
      ]),
      nombre: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50),
      ]),
      descripcion: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100),
      ]),
      activado: new FormControl(true),
      rut_empresa: new FormControl(''),
    });
  }
  /********************************************************************/

  obtenerDatosCentroCosto(rutEmpresa: number, sucursalcodigo: number) {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query($rut_empresa: Decimal, $tipobusqueda: Int, $nombre: String) {
            centro_costo {
              obtenerSegunFiltro(
                filtro: {
                  exacto: {
                    rut_empresa: $rut_empresa
                    tipobusqueda: $tipobusqueda
                    nombre: $nombre
                  }
                }
              ) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    activado
                    descripcion
                    rut_empresa
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rut_empresa: rutEmpresa,
          tipobusqueda: this.busquedaEstado,
          nombre: String(this.nombreBusquedaCC).toUpperCase(),
        },
      },
      function (respuesta) {
        self.listaCentroCosto =
          respuesta.data.centro_costo.obtenerSegunFiltro.respuesta.registros;
      }
    );
  }

  muestraModalAgrega() {
    this.centroCostoSel = {
      rut_empresa: null,
      codigo: null,
      descripcion: '',
      activado: true,
      nombre: null,
    };
    this.formAgregarCentroCosto.reset();
  }

  insertar() {
    this.centroCostoSel = {
      codigo: this.formAgregarCentroCosto.get('codigo').value.toUpperCase(),
      nombre: this.formAgregarCentroCosto.get('nombre').value.toUpperCase(),
      descripcion: this.formAgregarCentroCosto.get('descripcion').value.toUpperCase(),
      activado: this.formAgregarCentroCosto.get('activado').value,
      rut_empresa: this.rutEmpresa,
    };

    this.postCentroCosto(this.centroCostoSel);
  }
  postCentroCosto(nuevoCentroCosto: centro_costo) {
    const self = this;
    const bodyx = nuevoCentroCosto;
    delete bodyx['__typename'];

    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: centro_costoInputType) {
            centro_costo {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  descripcion
                  activado
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.centro_costo.guardar.respuesta == null) {
          if (respuesta.data.centro_costo.guardar.mensajes.length > 0) {
            alert(respuesta.data.centro_costo.guardar.mensajes[0].texto);
          }
        }

        setTimeout(
          () =>
            self.obtenerDatosCentroCosto(self.rutEmpresa, self.sucursalCodigo),
          1000
        );
      }
    );
  }

  validaExisteCentroCosto() {
    const self = this;
    this.centroCostoSel = {
      codigo: this.formAgregarCentroCosto.get('codigo').value.toUpperCase(),
      nombre: this.formAgregarCentroCosto.get('nombre').value.toUpperCase(),
      descripcion: this.formAgregarCentroCosto.get('descripcion').value.toUpperCase(),
      activado: this.formAgregarCentroCosto.get('activado').value,
      rut_empresa: this.rutEmpresa,
    };
    const bodyx = this.centroCostoSel;

    delete bodyx['__typename'];



    this.client.query(
      {
        query: gql`
          query($entidad: centro_costoInputType) {
            centro_costo {
              existe(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        fetchPolicy: "network-only",
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.centro_costo.existe.respuesta == null) {
          if (respuesta.data.centro_costo.xiste.mensajes.length > 0) {
            alert(respuesta.data.centro_costo.existe.mensajes[0].texto);
          }
        } else {
          if (respuesta.data.centro_costo.existe.respuesta === true) {
            const res = window.confirm('El código ingresado existe. ¿Desea modificar el registro existente?');
            if (res) {
              self.insertar();
            }
          } else{
            self.insertar();
          }

        }

        setTimeout(
          () =>
            self.obtenerDatosCentroCosto(self.rutEmpresa, self.sucursalCodigo),
          1000
        );
      }
    );
  }

  showForEdit(cc: centro_costo) {
    this.centroCostoSel = Object.assign({}, cc);
    this.formEditarCentroCosto.reset();
    this.formEditarCentroCosto
      .get('codigo')
      .setValue(this.centroCostoSel.codigo);
    this.formEditarCentroCosto
      .get('nombre')
      .setValue(this.centroCostoSel.nombre);
    this.formEditarCentroCosto
      .get('descripcion')
      .setValue(this.centroCostoSel.descripcion);
    this.formEditarCentroCosto
      .get('activado')
      .setValue(this.centroCostoSel.activado);
  }
  actualizar() {
    this.centroCostoSel = {
      descripcion: this.formEditarCentroCosto.get('descripcion').value.toUpperCase(),
      codigo: this.formEditarCentroCosto.get('codigo').value.toUpperCase(),
      activado: this.formEditarCentroCosto.get('activado').value,
      nombre: this.formEditarCentroCosto.get('nombre').value.toUpperCase(),
      rut_empresa: this.rutEmpresa,
    };

    this.postCentroCosto(this.centroCostoSel);
  }

  cambiaEstado(ccSel: centro_costo) {
    if (ccSel.activado) {
      ccSel.activado = false;
    } else {
      ccSel.activado = true;
    }
    this.postCentroCosto(ccSel);
  }
  filtraxEstado() {
    this.obtenerDatosCentroCosto(
      Number(this.rutEmpresa),
      Number(this.sucursalCodigo)
    );
  }
  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(ccSel: centro_costo) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(ccSel);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
